import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { ButtonGroup, Button } from 'reactstrap';
import { Link } from "react-router-dom";
import PeriodForm from '../PeriodForm/PeriodForm';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { Utils } from '../../../services';
import { loadPeriod, updatePeriod } from '../../../redux/modules/periods';

const PeriodEdit = ({ match }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        const periodId = match.params.periodId;
        // Load period on component mount
        dispatch(loadPeriod(periodId));
    }, [dispatch])

    const submit = (values) => {
        dispatch(updatePeriod(values));
    }

    const { period } = useSelector(state => state.periods);

    let title = <span>{t('periods.update_period')}</span>;

    if (period && period.name)
        title = (
            <span>
                {t('periods.period', {count: 1})}
                <small> |&nbsp;{ t('periods.update_period', { name: period.name[Utils.default_lang()] })} </small>
            </span>
        );

    const actions =
        <div>
            {period &&
            <ButtonGroup>
                <Button  tag={Link} to="/periods" color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t('common.back')}
                </Button>
            </ButtonGroup>
            }
        </div>

        return (
            <div className="PeriodEdit">
                <PageTitle icon="sun-o" title={ title } actions={ actions } />

                {period &&
                    <PeriodForm periodId={period._id} onSubmit={ submit } />
                }
            </div>
        );
}

export default PeriodEdit;
